/* Blog post templates: jump bar under the theme header, scroll-spy, rail offset, how-to spine. */
(function () {
  var root = document.querySelector('.bph');
  if (!root) return;
  var bar = root.querySelector('.jbar');
  var hero = root.querySelector('.hero');
  var art = root.querySelector('.art');
  var line = root.querySelector('.jb-line');
  var ol = bar ? bar.querySelector('ol') : null;
  var links = bar ? [].slice.call(bar.querySelectorAll('a')) : [];
  var secs = links.map(function (a) { return document.getElementById(a.getAttribute('href').slice(1)); });
  var spine = root.querySelector('.spine');
  var fill = root.querySelector('.spine-fill');
  var steps = [].slice.call(root.querySelectorAll('.sstep'));
  var docEl = document.documentElement;

  /* FAQ: one answer open at a time (backs up details[name] in older browsers). */
  var faqs = [].slice.call(root.querySelectorAll('.pfaq details'));
  faqs.forEach(function (d) {
    d.addEventListener('toggle', function () {
      if (!d.open) return;
      faqs.forEach(function (o) { if (o !== d && o.open) o.open = false; });
    });
  });

  /* The theme header is sticky and hides on scroll down, so read its live bottom edge. */
  var hdr = null;
  (function findHeader() {
    var el = document.querySelector('header');
    while (el && el !== document.body) {
      var p = getComputedStyle(el).position;
      if (p === 'sticky' || p === 'fixed') { hdr = el; return; }
      el = el.parentElement;
    }
  })();
  /* The sticky wrapper stays put while the theme slides the inner header up, so use whichever edge is higher. */
  var inner = document.querySelector('header');
  function hdrBottom() {
    if (!hdr) return 0;
    var b = hdr.getBoundingClientRect().bottom;
    if (inner) b = Math.min(b, inner.getBoundingClientRect().bottom);
    return b > 0 ? b : 0;
  }

  var cur = -1, ticking = false, lastTop = -1;
  function spy() {
    ticking = false;
    var top = Math.round(hdrBottom());
    if (top !== lastTop) {
      lastTop = top;
      docEl.style.setProperty('--bph-hdr', top + 'px');
    }
    var show = bar ? (hero ? hero.getBoundingClientRect().bottom <= top : true) : false;
    var jbH = show ? bar.offsetHeight : 0;
    /* Rail sits just under whatever is pinned right now (header and/or jump bar). */
    docEl.style.setProperty('--rail-top', (top + jbH + 18) + 'px');
    /* Anchors allow for the header too, since it slides back in on upward jumps. */
    var full = (hdr ? hdr.offsetHeight : 0) + (bar ? bar.offsetHeight : 0) + 18;
    docEl.style.setProperty('--anchor-top', (full + 6) + 'px');

    if (bar) {
      var edge = top + jbH + 120, idx = 0;
      for (var i = 0; i < secs.length; i++) if (secs[i] && secs[i].getBoundingClientRect().top <= edge) idx = i;
      if (idx !== cur) {
        cur = idx;
        links.forEach(function (a, i) { a.setAttribute('aria-current', i === idx ? 'true' : 'false'); });
        if (ol && ol.scrollWidth > ol.clientWidth && links[idx]) {
          ol.scrollTo({ left: links[idx].offsetLeft - (ol.clientWidth - links[idx].offsetWidth) / 2, behavior: 'smooth' });
        }
      }
      bar.classList.toggle('jb-on', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      if (line && art) {
        var r = art.getBoundingClientRect(), span = r.height - window.innerHeight * 0.6;
        line.style.width = Math.max(0, Math.min(1, (edge - r.top) / span)) * 100 + '%';
      }
    }

    if (spine && fill) {
      var sr = spine.getBoundingClientRect(), mark = window.innerHeight * 0.45;
      fill.style.height = Math.max(0, Math.min(sr.height - 20, mark - sr.top - 10)) + 'px';
      steps.forEach(function (s) {
        var node = s.querySelector('.snode');
        if (!node) return;
        var n = node.getBoundingClientRect(), mid = n.top + n.height / 2;
        var next = s.nextElementSibling;
        while (next && !next.classList.contains('sstep')) next = next.nextElementSibling;
        var nx = next ? next.getBoundingClientRect().top : Infinity;
        s.classList.toggle('now', mid <= mark && nx > mark);
        s.classList.toggle('passed', mid <= mark && nx <= mark);
      });
    }
  }
  /* The theme header slides in and out over a few hundred ms; track it every frame until it settles. */
  var followUntil = 0, following = false;
  function follow() {
    spy();
    if (performance.now() < followUntil) requestAnimationFrame(follow); else following = false;
  }
  function queue() {
    followUntil = performance.now() + 600;
    if (!following) { following = true; requestAnimationFrame(follow); }
  }
  window.addEventListener('scroll', queue, { passive: true });
  window.addEventListener('resize', queue);
  spy();
})();
